import client from './client';

export const listCustomers = (params) => client.get('/customers', { params }).then((r) => r.data);
export const pageCustomers = (params) => client.get('/customers/page', { params }).then((r) => r.data);
// forChat=1: ô "Nhắn KH mới" — người có kênh CSKH/DVKH nhắn được MỌI KH nên bỏ giới hạn theo sale
// (BE nới scope). Các nơi khác (đề xuất hoàn tiền) để trống forChat -> vẫn chỉ KH thuộc quyền.
export const searchCustomers = (q, mine, forChat) =>
  client.get('/customers/search', { params: { q, mine: mine ? 1 : undefined, forChat: forChat ? 1 : undefined } }).then((r) => r.data);
export const getCustomer = (id) => client.get(`/customers/${id}`).then((r) => r.data);
export const customerDetail = (id) => client.get(`/customers/${id}/detail`).then((r) => r.data);
